<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import { computed } from "vue";
import { useListItem } from "@/hooks";
const props = defineProps<{ property: string }>();
const { index, item } = useListItem();
const data = computed(() => (item.value ? item.value[props.property] : 0));
const emit = defineEmits(["change"]);

function onUpdateModelValue(value: number | undefined) {
  if (!item.value) return;
  item.value[props.property] = value;
}

function onChange(value: number | undefined) {
  emit("change", { rowIndex: index.value, value: Number(value) });
}
</script>
<template>
  <nut-input-number
    class="mp-list-number-input"
    v-bind="$attrs"
    :modelValue="data"
    @update:modelValue="onUpdateModelValue"
    @change="onChange"
  >
    <template #left-icon v-if="$slots['left-icon']">
      <slot name="left-icon" />
    </template>
    <template #right-icon v-if="$slots['right-icon']">
      <slot name="right-icon" />
    </template>
  </nut-input-number>
</template>
